<template>
  <div>
    <van-loading v-if="loading" />
    <ul class="flex flex-col" v-else>
      <li
        v-for="item in goodsData"
        :key="item.itemId"
        v-log-view
        @view="logView(item)"
        class="h-115 flex items-center relative pt-8 pb-10 px-8 bg-white rounded-8 mb-10 select-none overflow-hidden"
        @click="toGoodsDetail(item)"
      >
        <div
          v-if="item.status === 20"
          class="absolute left-0 top-0 w-full h-full bg-black/40 text-white flex justify-center items-center text-20 font-bold"
        >
          {{ t("message.rankingList.soldOut") }}
        </div>
        <div
          :class="[
            'flex items-center size-full',
            item.status === 20 && 'blur-6',
          ]"
        >
          <img
            :src="item.mainImageUrl"
            alt=""
            class="size-100 rounded-8 object-cover"
          />
          <div class="flex flex-1 flex-col ml-6 h-full">
            <div class="flex-1">
              <div
                class="text-14 font-600 leading-19 text-#333 line-clamp-2 text-ellipsis"
              >
                {{ item.itemTitle }}
              </div>
            </div>
            <div class="flex items-end flex-1 leading-none">
              <span class="text-18 font-bold text-#FF64005">{{
                formatPrice(item.itemPrice)
              }}</span>
            </div>
            <div class="flex items-end">
              <div class="flex-1">
                <div
                  class="mb-4 flex items-center text-#999999 text-12 font-600"
                >
                  <template v-if="item.itemCommentScore">
                    <img :src="StarImage" class="size-13 mr-2" />
                    <span>{{ item.itemCommentScore.toFixed(1) }}</span>
                    ｜
                  </template>

                  <span v-if="item.saleCount"
                    >{{ getSaleCountLabel(item.saleCount) }}
                    {{ t("message.ai.sold") }}</span
                  >
                </div>
              </div>
              <img
                :src="CartImage"
                class="size-32"
                @click.stop="addToCart(item)"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useSetting } from "@/composables/use-setting";
import {
  logAFEvent,
  navigateTo,
  showSkuSelectorModal,
} from "@voghion/native-api";
import { saveWindowScrollTop } from "@/utils/cache";
import CartImage from "@/assets/images/ai-chat/cart.png";
import StarImage from "@/assets/images/ai-chat/star.png";
import { getSaleCountLabel } from "./utils/getSaleCountLabel";
import { GoodsSource } from "./utils/goods-source";

const props = defineProps<{
  goodsData: any[];
  loading?: boolean;
  source: GoodsSource;
}>();

const { formatPrice } = useSetting();
const addToCart = async (item) => {
  if (item.status === 20) {
    return;
  }
  showSkuSelectorModal({
    goodsId: item.itemId,
    confirmAction: 1,
    prePage: `${props.source}AddConfirm`,
    extraInfo: item.extraInfo,
  });
};

const logView = (item) => {
  logAFEvent({
    event: "showSPM",
    spm: props.source === GoodsSource.Message ? "01010630101" : "01010630201",
    spmName: `${props.source}Goods`,
    params: {
      goods_id: item.itemId,
      extraInfo: item.extraInfo,
    },
  });
};

const toGoodsDetail = (item) => {
  if (item.status === 20) {
    return;
  }
  logAFEvent({
    event: "clickSPM",
    spm: props.source === GoodsSource.Message ? "01010630101" : "01010630201",
    spmName: `${props.source}Goods`,
    params: {
      goods_id: item.itemId,
      extraInfo: item.extraInfo,
    },
  });
  saveWindowScrollTop();
  navigateTo({
    url: item.itemDetailJumpUrl,
  });
};

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.list-wrapper {
  background: #f8f8f8;
  min-height: calc(100vh - 44px);
}

.goods-list {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;

  .loading-area {
    text-align: center;
    padding: 100px 0;
    background: transparent;
  }

  .container {
    display: grid;
    align-items: start;
    justify-content: space-between;
  }
}
</style>
